import { render } from "./FormIssue.vue?vue&type=template&id=7db25a06"
import script from "./FormIssue.vue?vue&type=script&lang=js"
export * from "./FormIssue.vue?vue&type=script&lang=js"

import "./FormIssue.vue?vue&type=style&index=0&id=7db25a06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__